import { axiosInstance } from '../axios/axiosConfig';

const baseAPIUrl = 'AccountRecovery';

export function sendFindIdCode(email, language) {
  return axiosInstance.post(`/${baseAPIUrl}/SendCode`, { email, fn: 'FindId', language });
}

export function findId(email, code) {
  return axiosInstance.post(`/${baseAPIUrl}/FindId`, { email, code });
}

export function sendResetLink(userId, email, language) {
  return axiosInstance.post(`/${baseAPIUrl}/SendResetLink`, { userId, email, language });
}

export function checkResetCode(email, code) {
  return axiosInstance.post(`/${baseAPIUrl}/CheckCode`, {
    Email: email,
    Code: code,
    Fn: 'ResetPassword'
  });
}

export function resetPassword(email, code, newPwd) {
  return axiosInstance.post(`/${baseAPIUrl}/ResetPassword`, {
    Email: email,
    Code: code,
    NewPwd: newPwd
  });
}

export function checkVerificationCode(email, code, fn) {
  return axiosInstance.post(`/${baseAPIUrl}/CheckCode`, { Email: email, Code: code, Fn: fn });
}

export function checkUserNameExists(userName) {
  return axiosInstance.post(`/${baseAPIUrl}/CheckUserName`, { userName });
}